import React from "react";
import ReactGoogleMapLoader from "react-google-maps-loader";

export const Map = (props) => {
    const sites = props.additionalData || null;

    return (
        <ReactGoogleMapLoader
            params={{
                key: 'AIzaSyA0Kezn_SPL4JkDuBCTzTxtS0x2bA2Ykvo',
            }}
            render={(googleMaps, error) =>
                googleMaps ? <div>{props.mapData(googleMaps, sites)}</div> : (
                    <div>
                        {error === "Network Error" ? (
                            <p>{error}</p>
                        ) : (
                            <p>isLoading...</p>
                        )}
                    </div>
                )
            }
        />
    )
}
